import { Schedule, ScheduleType } from '@octano/global-ui';
import { Row } from 'reactstrap';

import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Col } from 'reactstrap';
import DisplayError from '../../../components/Info/DisplayError';
import Loading from '../../../components/Info/Loading';
import useTimeModules from '../../../hooks/useTimeModules';
import sortSectionSchedule from '../../../utils/sortSectionSchedule';
import { useTeacherScheduleLoader } from '../provider/TeacherScheduleLoader';
import CourseTypeLegends from './CourseTypeLegends';
import { TranslationsKeys } from '../../../locales/translations';

export default function ScheduleInfo() {
  const { t } = useTranslation(TranslationsKeys.TEACHER_SCHEDULE);
  const { data, loading, error } = useTeacherScheduleLoader();
  const { isLoading: loadingModules, timeModules: modules } = useTimeModules();

  const schedules = useMemo(() => {
    let results: ScheduleType[] = [];

    if (data) {
      data.forEach(({ sectionData, course }) => {
        sortSectionSchedule(sectionData.sectionSchedules).forEach(
          (schedule) => {
            results.push({
              sectionId: sectionData.id,
              scheduleId: schedule.id,
              courseCode: sectionData.name,
              sectionName: course.shortening,
              day: schedule.day,
              activityId: schedule.activity.id,
              moduleStartId: schedule.startModule.id,
              moduleEndId: schedule.endModule
                ? schedule.endModule.id
                : schedule.startModule.id,
              tooltip: {
                courseName: course.name,
                sectionTitle: '',
                sectionName: sectionData.name,
                teachers: sectionData.professors.map(
                  (professor) =>
                    professor?.account?.fullName ||
                    `${professor?.account?.name} ${professor?.account?.paternalLastName}` ||
                    '',
                ),
                teachersTitle: t(`teacher`),
                classroom: schedule.classroom?.name || '',
              },
            });
          },
        );
      });
    }
    return results;
  }, [data, t]);

  const text = useMemo(
    () => ({
      empty: {
        title: t(`noSectionsMessage`),
        body: t(`noSectionsMessage`),
      },
      error: {
        title: t(`common.displayError.title`),
        body: t(`common.displayError.errorUnexpected`),
      },
    }),
    [t],
  );

  if (loading || loadingModules) {
    return <Loading insideCard />;
  }

  if (error || !data?.length) {
    return (
      <DisplayError
        insideCard
        loadingAction={loading || loadingModules}
        title={error ? text.error.title : text.empty.title}
        textBody={error ? text.error.body : ''}
      />
    );
  }

  return (
    <Row>
      <Col md={{ size: 10, offset: 1 }}>
        <Schedule
          schedules={schedules}
          modules={modules}
          mobileNavigation={true}
        />
      </Col>
      <Col md={{ size: 10, offset: 1 }} className="mt-5">
        <CourseTypeLegends />
      </Col>
    </Row>
  );
}
